module.exports = __webpack_public_path__ + "static/media/fortune_teller.806c84f3.png";